import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Swallow cross-origin "Script error." events (usually from 3rd-party scripts/embeds)
// so the webpack-dev-server error overlay doesn't block the UI in development.
if (typeof window !== "undefined") {
  window.addEventListener(
    "error",
    (e) => {
      if (e && e.message === "Script error." && !e.error) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true
  );
  window.addEventListener("unhandledrejection", (e) => {
    const reason = e && e.reason;
    const msg = reason && (reason.message || String(reason));
    if (msg === "Script error." || (typeof msg === "string" && msg.includes("Script error"))) {
      e.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
